module.exports = __webpack_public_path__ + "static/dnicon1-fa0a74826240895cadc8d3ab21886218.png";